<template>
  <div id="app">
    <router-view></router-view>

    <caring-im></caring-im>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
export default {
  name: 'app',
  data: function () {
    return {}
  },
  computed: {
    access_token: function () {
      return this.$store.state.access_token
    },
    lastSessions: function () {
      return this.$store.state.lastSessions
    },
    ...mapGetters(['im'])
  },
  components: {
    'caring-im': () => import('./components/caring-im')
  },
  watch: {
    'im.im_token': function (newVal) {
      console.log(newVal)
      if (newVal) {
        this.initNIM()
      } else {
        // 断开NIM连接
        if (this.$nim) {
          console.log('销毁NIM。。。')
          this.$nim.destroy({
            done: () => {
              console.log('销毁NIM成功~~~')
              Vue.prototype.$nim = null
            },
          })
          this.$store.commit('setLastSessionsHaveData', false)
          this.$store.commit('setLastSessions', [])
          this.$store.commit('setLastSession', null)
          this.$store.commit('setBadge', 0)
        }
      }
    },
    lastSessions: function (newVal) {
      newVal = newVal || []
      var badge = 0
      newVal.forEach((i) => {
        badge += i.unread
      })
      this.$store.commit('setBadge', badge)
    },
  },
  mounted() {
    // console.log(this.$store.state)
    if (this.$store.state.im.im_token) {
      this.initNIM()
    }
  },
  methods: {
    initNIM: function () {
      const startConnect = () => {
        setTimeout((_) => {
          console.log('连接之前:)')
          const userInfo = this.$store.state.im
          console.log(userInfo, 1111)
          // console.log(userInfo, this.$store.state.nim_appKey)
          // console.log({
          //   appKey: this.$store.state.nim_appKey,
          //   account: userInfo.username,
          //   token: userInfo.im_token
          // })
          const nim = window.NIM.getInstance({
            debug: false, // 是否开启日志，将其打印到console。集成开发阶段建议打开。
            appKey: this.$store.state.nim_appKey,
            account: userInfo.username,
            token: userInfo.im_token,
            db: true, // 若不要开启数据库请设置false。SDK默认为true。
            syncSessionUnread: true,
            // syncRobots: true,
            // syncTeams: true,
            // onteams: (error) => {
            // 	console.log('onteams', error)
            // },
            // onsyncdone: (error) => {
            // 	console.log('onsyncdone', error)
            // },
            onconnect: () => {
              console.log('连接成功')
              console.log()
              setTimeout((_) => {
                this.$store.commit('setLastSessionsHaveData', true)
              }, 5000)
            },
            oncustomsysmsg: (event) => {
              console.log(event)
              // if (!event) return

              // event.content = JSON.parse(event.content)
              // const content = event.content
              // if (content.cus_extra.cv_status === 1004) { // 来了新的音视频邀请
              //   uni.navigateTo({
              //     url: '/package/pages/av/av?info=' + encodeURIComponent(JSON.stringify(content))
              //   })
              // } else if (content.cus_extra.cv_status === 1003) { // 对方取消音视频邀请
              //   const pages = getCurrentPages()
              //   if (pages[pages.length - 1].route === 'package/pages/av/av') { // 在来电显示界面
              //     this.$utils.toast('对方取消通话')
              //     uni.navigateBack()
              //   }
              // }
            },
            ondisconnect: (error) => {
              // 此时说明 SDK 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
              console.log('丢失连接', error)
              if (error.code && error.code !== 'logout') {
                this.$Modal.info({
                  title: '提示',
                  content:
                    error.code === 'kicked'
                      ? '您的账号近期在其他设备登录过，为保证账号安全，请重新登录。若非本人操作，建议及时修改密码。如有问题，请联系管理员。'
                      : error.message,
                  onOk: () => {
                    // this.$store.commit('setUserInfo', null)
                    // setTimeout(_ => {
                    //   this.$router.replace({
                    //   name: 'login'
                    // })
                    // }, 400)
                    this.$store.commit('setSessionModal', false)
                    this.$store.dispatch('Logout').finally(() => {
                      this.$router.replace({
                        path: '/user/login',
                        query: { redirect: this.$route.fullPath },
                      })
                    })
                  },
                })
              }
            },
            onerror: (error) => {
              console.log(error)
            },
            onsessions: (sessions) => {
              console.log(sessions)
              sessions = sessions
                .filter((item) => ['team', 'p2p'].includes(item.scene))
                .filter((item) => item.id !== 'p2p-1208_robot')
              const getInfo = (id) => {
                // 获取用户or群详情
                return new Promise((resolve, reject) => {
                  const type = id.split('-')[0]
                  id = id.split('-')[1]
                  if (type === 'p2p') {
                    nim.getUser({
                      account: id,
                      done: (error, obj) => {
                        resolve(obj)
                      },
                    })
                  } else {
                    nim.getTeam({
                      teamId: id,
                      done: (error, obj) => {
                        resolve(obj)
                      },
                    })
                  }
                })
              }

              Promise.all(sessions.map((item) => item.id).map(getInfo)).then(
                (result) => {
                  // console.log(result)
                  result.forEach((item, index) => {
                    if(item.name && item.name.indexOf('-') != -1) {
                       let innerIndex = item.name.lastIndexOf('-')
                       item.name = item.name.substring(0, innerIndex).concat(')')
                    }
                    sessions[index].detail = item

                  })

                  this.$store.commit('setLastSessionsHaveData', true)
                  this.$store.commit(
                    'setLastSessions',
                    nim.mergeSessions(this.$store.state.lastSessions, sessions)
                  )
                }
              )
            },
            onupdatesession: (session) => {
              console.log(session)
              const getInfo = (id) => {
                // 获取用户or群详情
                return new Promise((resolve, reject) => {
                  const type = id.split('-')[0]
                  id = id.split('-')[1]
                  if (type === 'p2p') {
                    nim.getUser({
                      account: id,
                      done: (error, obj) => {
                        resolve(obj)
                      },
                    })
                  } else {
                    nim.getTeam({
                      teamId: id,
                      done: (error, obj) => {
                        resolve(obj)
                      },
                    })
                  }
                })
              }
              getInfo(session.id).then((result) => {
                // console.log(result)
                session.detail = result
              })

              if (
                ['text', 'image', 'custom', 'notification', 'audio'].includes(
                  session.lastMsg.type
                )
              ) {
                this.$store.commit('setLastSession', session)
                this.$store.commit(
                  'setLastSessions',
                  nim.mergeSessions(this.$store.state.lastSessions, session)
                )
                if (['text', 'image'].includes(session.lastMsg.type)) {
                  // uni.vibrateLong() // 手机震动 (iOS上只有长震动，没有短震动)
                }
              }
            },
            onmsg: (msg) => {
              // console.log('msg:', msg)
              // this.$store.commit('setLastSession', msg)
            },
          })
          Vue.prototype.$nim = nim
          setTimeout((_) => {
            this.$store.commit('setLastSessionsHaveData', true)
          }, 10000)
        }, 100)
      }

      if (this.$nim) {
        console.error('销毁NIM...')
        this.$nim.destroy({
          done: () => {
            console.log('销毁NIM成功~~~')
            Vue.prototype.$nim = null
            startConnect()
          },
        })
        this.$store.commit('setLastSessionsHaveData', false)
        this.$store.commit('setLastSessions', [])
        this.$store.commit('setLastSession', null)
        this.$store.commit('setBadge', 0)
        return
      }

      startConnect()
    },
  },
}
</script>

<style lang="less">
// @import '//at.alicdn.com/t/font_983435_ld86jxvgmbn.css'; // iconfont
@import './styles/iconfont/iconfont.css';
@import 'styles/common.less';

html,
body,
#app {
  height: 100%;
  position: relative;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
.app-section {
  width: 100%;
  height: 100%;
  position: relative;
  // overflow: hidden;
}
.sub-route {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  background-color: #fff;
  will-change: transform;
}
.sub-sub-route {
  z-index: 1;
}
.sub-sub-sub-route {
  z-index: 2;
}

.animated {
  animation-duration: 0.6s;
  will-change: transform;
}
// .primary-theme-btn:active {
//   background-color: $theme-opacity-color;
// }
/*以下为页面过渡动画效果*/
// .slide-fade-enter-active {
//   transition: all .5s ease;
// }
// .slide-fade-leave-active {
//   transition: all .5s ease;
// }
// .slide-fade-enter, .slide-fade-leave-to
// /* .slide-fade-leave-active for below version 2.1.8 */ {
//   transform: translateX(300px);
//   opacity: 0;
// }
//
// .slide-fade-down-enter-active {
//   transition: all .5s ease;
// }
// .slide-fade-down-leave-active {
//   transition: all .5s ease;
// }
// .slide-fade-down-enter, .slide-fade-down-leave-to
// /* .slide-fade-leave-active for below version 2.1.8 */ {
//   transform: translateY(100%);
//   opacity: 0;
// }

.show-form {
  .ivu-form-item {
    margin-bottom: 10px !important;
  }
}

.ivu-form-item-label {
  word-break: break-all;
}

// .ivu-tabs {
//   overflow: visible !important;
// }
.ivu-table td {
  padding: 12px 0;
}
.ivu-picker-confirm {
  .ivu-btn + .ivu-btn{
    margin-left: 10px;
  }
}
#pendingOrders {
  .ivu-table td {
    padding: 10px 0 !important;
  }
}
.code-btn{
  &.el-button.is-loading:before{
    background: transparent;
  }
}
#app {
  min-width: 1280px;
  margin: 0 auto;

  .el-menu {
    border-right: none;
  }
  .el-main {
    padding: 0;
  }
  .ivu-tabs-bar {
    background-color: #fff;
  }
  #xiala {
    .ivu-input {
      height: 36px;
    }
  }
}
#pendingOrders .el-tree-node__content {
  /* margin: 6px 0; */
  height: 38px;
}
#pendingOrders .el-tree-node:focus > .el-tree-node__content {
  background: #e6efff !important;
  color: #84aef6 !important;
}
#pendingOrders .el-tree-node__content:hover {
  background: #e6efff !important;
  color: #84aef6 !important;
}
#pendingOrders
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #e6efff !important;
  color: #84aef6 !important;
}
#project_list_card {
  .ivu-form .ivu-form-item-label {
    font-size: 14px !important;
    color: #999 !important;
  }
  .ivu-form-item {
    margin-bottom: 0 !important;
  }
  div.ivu-card-body {
    padding: 0;
  }
  div.ivu-table-wrapper {
    border: none;
  }
  .ivu-table:before {
    content: '';
    width: 100%;
    height: 0px;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1;
  }
  .ivu-table:after {
    content: '';
    width: 0px;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 3;
  }
}

.moreInfo {
  > .ivu-card-body {
    padding: 0;
  }
  .el-tabs__item {
    font-size: 15px;
    height: 46px;
    line-height: 46px;
    padding: 0 16px !important;
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__nav-wrap:after {
    height: 1px;
  }
  .btn-icon {
    position: absolute;
    top: 50%;
    right: 0;
    padding: 8px 12px;
    transform: translateY(-50%);
    color: rgb(128, 141, 162);
    &:hover {
      color: #409eff;
    }
  }
}
.ivu-input-number-input::placeholder {
  font-size: 12px;
}
.ivu-form-item-error-tip {
  font-size: 13px;
}
* {
  font-size: 15px;
}
.diagnosis .el-input__inner {
  height: 32px;
  line-height: 32px;
  padding: 4px 7px;
}
.diagnosis .el-input__icon {
  line-height: 32px;
}
.colorpz .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.colorpz .el-input__icon {
  line-height: 32px;
}

.ivu-select-dropdown {
	max-height: 250px !important;
	overflow-y: auto !important;
}
</style>
